import React from 'react'
import { TabFooter, Button, Flex, Animation, Box } from 'styling/GlobalStyles'
import { Input } from 'components/Input/Input'
import { CancelBtn } from 'components/Button/CancelBtn'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { ICycleState, ICycleTab } from 'types/cycles.interface'
import { ISelectValue } from 'constants/globalTypes'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'

export const CycleSpecificationTab = ({ state, setState, handleSubmit, view }: ICycleTab) => {
    useFocusFirstInput()

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setState((prev: ICycleState) => {
            const copy = { ...prev }
            copy.name = e.target.value
            return copy
        })
    }

    const handleSelect = (value: ISelectValue) => {
        setState(prev => {
            const copy = structuredClone(prev)
            copy.componentIndexForNumberOfWorkers = value
            return copy
        })
    }

    const getOptions = () => {
        return state?.components.filter(c => c.name && c.component).map(c => ({ label: c.name, value: state.components.findIndex(cmp => cmp.component == c.component) }))
    }

    return (
        <Animation>
            <Box>
                <Flex gap='1rem' column width='15rem' >
                    <Input
                        type='text'
                        value={state?.name}
                        onChange={handleChange}
                        placeholder='Enter task cycle name'
                        labelText='Task cycle name'
                        invalid={state?.name?.length < 2 ? 'true' : ''}
                        nomarg
                        view={view}
                    />

                    {(view ? getOptions()?.length : true) && <HonestSelectInput
                        name='componentIndexForNumberOfWorkers'
                        onChange={handleSelect}
                        labelText='Component for Number of Workers'
                        defaultValue={state?.componentIndexForNumberOfWorkers?.value}
                        options={getOptions()}
                        nomarg
                        errorWhenEmpty='Components must be selected first.'
                        view={view}
                    />}
                </Flex>
            </Box>

            {handleSubmit && (
                <TabFooter>
                    <Flex width='100%' end='true'>
                        <CancelBtn />
                        <Button ml='15' height='40' onClick={handleSubmit} orange>
                            Save
                        </Button>
                    </Flex>
                </TabFooter>
            )}
        </Animation>
    )
}
